import { useCallback, useEffect, useState } from "react";
import { useSharedState } from "sharedStateProvider";
import { emptyPagination } from "types/pagination-types";
import PageLayout from "components/page-layout";
import Table, { tableHeader } from "components/tables/table";
import { oneLine, userLine } from "components/tables/table-parts";
import {getAdminLogs} from "../../api/logs";
import { getApiErrorMessage } from "api/error";

type LogType = {
  id: string;
  input: string;
  ip: string;
  method: string;
  path: string;
  service: string;
  user_id: string;
  created_at: string;
};
type LogsResponseType = {
  data: LogType[];
  page: number;
  size: number;
  sort: string;
  total: number;
};

export default function Logs() {
  const { notify } = useSharedState();

  const [logs, setLogs] = useState<LogsResponseType>(emptyPagination);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getAndSetLogs = useCallback(async (page?: number) => {
    setIsLoading(true);
    try {
      const res: LogsResponseType = await getAdminLogs(page);
      setLogs(res);
    } catch (error: unknown) {
      notify(getApiErrorMessage(error, "Ошибка при загрузке логов"), "danger", "Ошибка при загрузке логов");
    } finally {
      setIsLoading(false);
    }
  }, [notify]);

  useEffect(() => {
    getAndSetLogs();
  }, [getAndSetLogs]);

  const logsTableHeaders: tableHeader[] = [
    { header_text: "ID", narrow: true, wrap: false },
    { header_text: "Пользователь", narrow: false, wrap: false },
    { header_text: "IP", narrow: false, wrap: false },
    { header_text: "Сервис", narrow: false, wrap: false },
    { header_text: "Метод", narrow: false, wrap: false },
    { header_text: "URL", narrow: false, wrap: false },
    { header_text: "Input", narrow: false, wrap: true },
    { header_text: "Когда", narrow: false, wrap: false },
  ];

  const logsList = (
    <>
      {logs.data.map((log, index) => (
        <tr key={index}>
          <td>{oneLine(log.id)}</td>
          <td>{userLine(log.user_id)}</td>
          <td>{oneLine(log.ip)}</td>
          <td>{oneLine(log.service)}</td>
          <td>{oneLine(log.method)}</td>
          <td>{oneLine(log.path)}</td>
          <td className={'actionCell'}>
            {oneLine(log.input)}
          </td>
          <td>{oneLine(new Date(log.created_at).toLocaleString())}</td>
        </tr>
      ))}
    </>
  );

  const logsTable = Table(
      logsTableHeaders,
      logsList,
      true,
      logs,
      undefined,
      getAndSetLogs
  );

  const logsHeader = "Логи админов";
  const logsSubheaderText = "Количество записей: ";
  const logsSubheaderCount = logs.total;

  return (
    <>
      <PageLayout
        children={logsTable}
        isLoading={isLoading}
        filters={false}
        search={false}
        header={logsHeader}
        subheaderText={logsSubheaderText}
        subheaderCount={logsSubheaderCount}
        dataLength={logs.data.length}
        dateRange={false}
      />
    </>
  );
}
